export default __webpack_public_path__ + "static/media/asset3.009fd6b1.png";